import type { OnboardingEmailChangeEligibilityResultAjax } from './onboarding-email-change.backend-model';
import type { OnboardingEmailChangeDocument } from './onboarding-email-change.model';

export function transformOnboardingEmailChangeEligibility(
  result: OnboardingEmailChangeEligibilityResultAjax,
): OnboardingEmailChangeDocument {
  return {
    id: `onboarding-email-change-eligibility`,
    email: '',
    isEligible: result.is_eligible,
  };
}
